import React from 'react';
import { ContractService } from '../../services/contract/contractService';
import SendEmailForm from './SendEmailForm';

interface SendContractEmailFormProps {
    onClose: () => void;
    contractId: string;
    clientEmail: string;
}

const SendContractEmailForm: React.FC<SendContractEmailFormProps> = ({ onClose, contractId, clientEmail }) => {
    const contractService = {
        sendEmail: (data: any) => new ContractService().sendContractEmail({ ...data, clientEmail: clientEmail })
    };

    return (
        <SendEmailForm
            onClose={onClose}
            entityType="contract"
            entityId={contractId}
            service={contractService}
            entityFieldName="contractId"
        />
    );
};

export default SendContractEmailForm;